<template>
  <div class="cursor pro-item mb-20" :class="index % 4 === 0 ? '' : 'ml-20'" @click="toDetail">
    <div class="pic">
      <img src="/images/tejia.png" alt="" class="icon" v-if="goodsItem.isPeferential">
      <el-image :src="Utils.IMG_PREV + goodsItem.goodsPicList[imgIndex].pic + '?x-oss-process=image/resize,w_400'"
        :preview-src-list="goodsItem.goodsPicList" fit="cover" class="w-100 h-100" lazy></el-image>
      <div class="mask" :class="isSwitch ? 'bg-eeeff3' : 'bg-transparent'"></div>
      <div class="imgList flex align-center">
        <div class="img-item cursor mr-5" :style="{
            background: 'url(' + Utils.IMG_PREV + item.pic + '?x-oss-process=image/resize,w_150'
              + ') no-repeat center/cover'
          }" v-for="(item, index) in goodsItem.goodsPicList" :key="index" @mouseenter="onImg(index)">
          <div class="w-100 h-100" :class="index === imgIndex ? 'bg-c19357-5' : ''"></div>
        </div>
      </div>
    </div>
    <div class="bottom flex align-center justify-space-between">
      <div class="flex-1 mr-40 w-0">
        <div class="font-16 color-ff font-yahei mb-6 flex align-center">
          <div>{{ goodsItem.styles }}</div>
          <div class="line"></div>
          <div class="text-overflow w-0 flex-1">{{ goodsItem.name || '-' }}</div>
        </div>
        <div class="font-12 color-94 text-overflow w-100 mb-28">{{ goodsItem.profile || '-' }}</div>
        <span class="font-18 color-c19357 font-arial">¥{{ goodsItem.isPeferential ?
          Utils.toFixedNum(goodsItem.preferentialPrice) : Utils.toFixedNum(goodsItem.price) }}</span>
        <span class="font-12 color-ca font-arial ml-5" style="text-decoration:line-through"
          v-if="goodsItem.isPeferential">¥{{ Utils.toFixedNum(goodsItem.price) }}</span>
      </div>
      <img src="/images/jinruxiangqing.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "Index",
  components: {},
  props: ['index', 'isDiscount', 'goodsItem'],
  data () {
    return {
      imgIndex: 0,
      isSwitch: false
    }
  },
  created () { },
  mounted () {
  },
  methods: {
    toDetail () {
      let url = this.$router.resolve({ name: 'GoodsDetail', query: { goodId: this.goodsItem.id + '.html' } })
      window.open(url.href, '_blank')

    },
    chooseGoods () {
      this.isSelect = !this.isSelect
    },
    onImg (e) {
      this.imgIndex = e
    },
    onDelete () {
      this.$emit('delete', this.index)
    }
  },
  watch: {
    imgIndex (e) {
      this.isSwitch = true
      setTimeout(() => {
        this.isSwitch = false
      }, 300)
    }
  }
};
</script>

<style lang="scss" scoped>
.pro-item {
  width: 335px;

  .pic {
    height: 220px;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    position: relative;

    .icon {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
    }

    .imgList {
      position: absolute;
      z-index: 9;
      bottom: 10px;
      left: 30px;

      .img-item {
        width: 40px;
        height: 26px;
        border: 1px solid #292a2e;
        border-radius: 4px;
        overflow: hidden;
      }
    }

    .mask {
      height: 220px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 8;
      transition: all 1.5s ease;
    }
  }

  .bottom {
    padding: 26px 30px;
    width: 100%;
    background: #292a2e;
    border-radius: 4px;

    .line {
      height: 16px;
      width: 1px;
      background: #7d7d7d;
      margin: 2px 6px 0;
    }
  }
}
</style>
